import { render, staticRenderFns } from "./Shifu.vue?vue&type=template&id=07f6859d&scoped=true&"
import script from "./Shifu.vue?vue&type=script&lang=js&"
export * from "./Shifu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f6859d",
  null
  
)

export default component.exports